
import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';

export const useSentryStatusCheck = () => {
  const [sentryStatus, setSentryStatus] = useState<'checking' | 'configured' | 'not-configured'>('checking');

  useEffect(() => {
    const checkSentryStatus = async () => {
      try {
        const client = Sentry.getClient();
        if (client && client.getOptions && client.getOptions().dsn) {
          setSentryStatus('configured');
        } else {
          setSentryStatus('not-configured');
        }
      } catch {
        setSentryStatus('not-configured');
      }
    };

    const timer = setTimeout(checkSentryStatus, 500);
    return () => clearTimeout(timer);
  }, []);

  return sentryStatus;
};
